function stringifyError(error): string {
  if (error instanceof Error) {
    return JSON.stringify(error, Object.getOwnPropertyNames(error));
  }

  if (error instanceof MediaError) {
    return `MediaError ${JSON.stringify(error, ['code', 'message'])}`;
  }

  return JSON.stringify(error);
}

export default stringifyError;
